import { useCallback } from 'react';

import { type Clip, type Tag, type UnmadeTag } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';

export type TrackRemovedAssetsTagsParams = {
  assets: Clip['id'][];
  tags: (Tag | UnmadeTag)[];
  location: AirActionTrackingLocation;
  selectAll?: boolean;
};

export const useTrackRemovedTagsFromAssets = () => {
  const { track } = useAnalyticsUtilities();

  const trackRemovedTagsFromAssets = useCallback(
    (params: TrackRemovedAssetsTagsParams) => {
      track(`Removed tags from assets`, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackRemovedTagsFromAssets };
};
